import script from "./RowCheckBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./RowCheckBox.vue?vue&type=script&lang=ts&setup=true"

import "./RowCheckBox.vue?vue&type=style&index=0&id=848de4d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-848de4d0"]])

export default __exports__